import axios from "axios";
import axiosUrl from "./axios.service";
import store from "../store/index";
const API_URL = axiosUrl.getAxiosUrl();

class NotificationsService {
  async getAllNotifications() {
    return await axios
      .get(API_URL + "/notifications/getAllNotifications")
      .then(response => {
        if (response.data.success) {
          store.commit(
            "notifications/updateSchemeCreationNotifications",
            response.data
          );
        }
      })
      .catch(error => {
        if (error) {
          store.commit("notifications/updateModalError", error.response.data),
            store.commit("notifications/enableModalError");
        }
      });
  }

  async markNotificationAsSeen(id) {
    return await axios
      .post(API_URL + `notifications/markNotificationAsSeen`, {
        id: id
      })
      .then(response => {})
      .catch(error => {
        store.commit("notifications/updateModalError", error.response.data),
          store.commit("notifications/enableModalError");
      });
  }

  async deleteNotification(id) {
    return await axios
      .post(API_URL + `notifications/deleteNotification`, {
        id: id
      })
      .then(response => {})
      .catch(error => {
        store.commit("notifications/updateModalError", error.response.data),
          store.commit("notifications/enableModalError");
      });
  }
}

export default new NotificationsService();
